export default __webpack_public_path__ + "static/media/blog03.022b25ce.png";